// 바닥 이름표가 피해야 할 DOM 조작 영역(드롭 식별 회차, PR #229 리뷰): 연계 안내 줄·자동 버튼·자동 이동 알약·스킬 바(PC)·터치 조작 버튼·일시정지/전체화면/카메라.
// 목표 카드·영웅 초상·상태·미니맵은 shared/panelRects가 이미 매 프레임 알려 준다(렌더가 읽음). 이 모듈은 거기 없는 나머지를 0.5초마다·크기가 바뀔 때만 재서 돌려준다
// (getBoundingClientRect = 강제 레이아웃 읽기라 프레임마다 읽지 않는다). 사각형 객체는 미리 만들어 돌려 쓴다(프레임 안 할당 없음).
import { viewRect } from '../shared/viewport';
import type { ScreenRect } from '../shared/panelRects';

const SEL = '[data-testid="link-hint"],[data-testid="auto-status"],[data-testid="hud-auto"],[data-testid="skillbar"],[data-testid^="potion-"]:not([data-testid="potion-bar"]):not([data-testid*="count"]),[data-testid^="touch-"]:not([data-testid^="touch-editor"]),' +
  '[data-testid="pause"],[data-testid="fullscreen"],[data-testid^="camera-"]';
const MAX = 40;
/** 다시 재는 간격(ms)과 요소 목록을 다시 찾는 간격(ms) */
const MEASURE_MS = 500, QUERY_MS = 2000;

export class HudAvoid {
  private els: Element[] = [];
  private readonly pool: ScreenRect[] = [];
  private readonly out: ScreenRect[] = [];
  private nextMeasure = 0;
  private nextQuery = 0;
  private lastW = -1;
  private lastH = -1;

  constructor() { for (let i = 0; i < MAX; i++) this.pool.push({ x: 0, y: 0, w: 0, h: 0 }); }

  /** 예약 사각형(게임 화면 좌표). 돌려준 배열은 다음 호출까지만 유효하다 */
  update(nowMs: number, w: number, h: number): readonly ScreenRect[] {
    if (typeof document === 'undefined') return this.out;
    const due = nowMs >= this.nextMeasure || w !== this.lastW || h !== this.lastH;
    if (!due) return this.out;
    this.nextMeasure = nowMs + MEASURE_MS; this.lastW = w; this.lastH = h;
    if (nowMs >= this.nextQuery || (this.els.length > 0 && !this.els[0].isConnected)) {
      this.nextQuery = nowMs + QUERY_MS;
      this.els = Array.from(document.querySelectorAll(SEL));
    }
    this.out.length = 0;
    for (const el of this.els) {
      if (this.out.length >= MAX) break;
      if (!el.isConnected) continue;
      const r = viewRect(el);
      if (!(r.width > 0 && r.height > 0)) continue;
      const q = this.pool[this.out.length];
      q.x = r.left; q.y = r.top; q.w = r.width; q.h = r.height;
      this.out.push(q);
    }
    return this.out;
  }

  clear(): void { this.out.length = 0; this.nextMeasure = 0; this.nextQuery = 0; }
}
